import {
  useAccountAttributeElement,
  useHasPrivatePictures,
  useMemberAttribute,
  useSelectMyPictures,
  useSelectPictureUriById,
} from 'affiny-core/hooks';
import { EGender } from 'affiny-core/modules/account/types';
import { PICTURE_FORMAT } from 'affiny-core/modules/pictures/types';
import { Avatar, Box, rem, Score } from 'affiny-ui/src';
import React, { memo } from 'react';

interface ICompatibilityAvatars {
  size: number;
  accountId: string;
  score: number;
  gender: EGender;
}

export const CompatibilityAvatars = memo(
  ({ size, accountId, score, gender }: ICompatibilityAvatars) => {
    const myGender = useAccountAttributeElement('gender');
    const { mainPicture } = useSelectMyPictures();
    const hasPrivatePictures = useHasPrivatePictures(accountId);
    const pictureId = useMemberAttribute('mainPicture', accountId);
    const pictureUri = useSelectPictureUriById(pictureId);

    return (
      <Box display="flex" alignItems="center" mr={rem(-16)} ml={rem(-16)}>
        <Box left="medium">
          <Avatar
            size={size}
            hasPrivatePicture={hasPrivatePictures}
            pictureUri={pictureUri}
            gender={gender}
          />
        </Box>
        <Score
          value={score}
          size={size}
          isAnimated
          borderWidth={rem((size * 4) / 80)}
          borderColor="light"
          borderStyle="solid"
          boxSizing="content-box"
          zIndex={2}
          showCounterScore
        />
        <Box right="medium">
          <Avatar
            size={size}
            pictureUri={mainPicture?.attributes.formats[PICTURE_FORMAT.SMALL]}
            gender={myGender}
          />
        </Box>
      </Box>
    );
  }
);
